export default __webpack_public_path__ + "static/media/chainsofanguish.04801401.png";